import { render, staticRenderFns } from "./approveAuction.vue?vue&type=template&id=32e8d2ba&scoped=true"
import script from "./approveAuction.vue?vue&type=script&lang=js"
export * from "./approveAuction.vue?vue&type=script&lang=js"
import style0 from "./approveAuction.vue?vue&type=style&index=0&id=32e8d2ba&prod&lang=css&scoped=true"
import style1 from "./approveAuction.vue?vue&type=style&index=1&id=32e8d2ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e8d2ba",
  null
  
)

export default component.exports